export default "__VITE_ASSET__BtmcTDBj__"